import apiService from "./api";

const restaurantService = {
  // Get all restaurants
  getAllRestaurants(params) {
    return apiService.get('/restaurants', params);
  },
  // Meal ratings for a restaurant (aggregated, anonymous for restaurant users)
  getMealRatings(restaurantId, params) {
    return apiService.get(`/meal-ratings/restaurant/${restaurantId}`, params);
  },
  getRestaurantSuppliers(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/suppliers`);
  },
  attachSuppliersToRestaurant(restaurantId, supplierIds) {
    return apiService.post(`/restaurants/${restaurantId}/attach-suppliers`, { supplier_ids: supplierIds });
  },
  // Get restaurants for specific user
  getRestaurantsByUserId(userId) {
    return apiService.get(`/restaurants?user_id=${userId}`);
  },
  // Add warehouse users fetch
  getRestaurantUsers(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/users`);
  },
  getDailyCompanies(restaurantId, params) {
    return apiService.get(
      `/reports/daily/restaurant/${restaurantId}/companies`,
      params
    );
  },
  getGroupType(restaurantId, params) {
    return apiService.get(
      `/reports/restaurant/${restaurantId}/group-type-companies`,
      params
    );
  },
  getRestaurantCompanies(restaurantId, params) {
    return apiService.get(
      `/reports/daily/get-restaurant-companies/${restaurantId}`,
      params
    );
  },
  // Get all countries
  getCountriesAll() {
    return apiService.get('/restaurants/countries-all');
  },
  // Get restaurants by city
  getRestaurantsByCity(city) {
    return apiService.post('/restaurants/get-restaurant-by-city', city);
  },
  // Get all restaurants (alternative endpoint)
  getAllRestaurantsPublic() {
    return apiService.get('/all-restaurants');
  },
  // Get restaurant new times/ordering rules
  getRestaurantNewTimes(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/get-new-times`);
  },
  // Get delivery restaurants
  getDeliveryRestaurants() {
    return apiService.get('/delivery');
  },
  // Get delivery restaurant details
  getDeliveryRestaurantDetails(restaurantId, params) {
    return apiService.get(`/delivery/${restaurantId}`, params);
  },
  // Get restaurant questionnaires
  getRestaurantQuestionnaires(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/questionnaire`);
  },
  // Get restaurant services and cooperation terms
  getRestaurantServices(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/services`);
  },
  // Update restaurant services and cooperation terms
  updateRestaurantServices(restaurantId, services) {
    return apiService.put(`/restaurants/${restaurantId}/services`, { services });
  },
  // Get restaurant foods
  getRestaurantFoods(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/foods`);
  },
  // Check disabled date for restaurant
  checkRestaurantDisabled(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/check-disabled`);
  },
  // Get child restaurants
  getChildRestaurants(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}/child-restaurant`, params);
  },
  // Choose/select a restaurant
  chooseRestaurant(userId, restaurantId) {
    return apiService.post('/choose-restaurant', {
      user_id: userId,
      restoran_id: restaurantId,
    });
  },
  // Update restaurant settings
  updateRestaurantSettings(restaurantId, settings) {
    return apiService.patch(`/restaurants/${restaurantId}`, {
      settings: settings,
    });
  },
  // Update restaurant language (dialect)
  updateRestaurantLanguage(restaurantId, language) {
    return apiService.post(`/restaurants/${restaurantId}/lang`, {
      restaurants: restaurantId,
      jezik: language,
    });
  },
  // Update restaurant text language (alphabet)
  updateRestaurantTextLanguage(restaurantId, data) {
    return apiService.post(`/restaurants/${restaurantId}/text-lang`, {
      user: restaurantId,
      ...data,
    });
  },
  // Add parent menu to restaurant
  addParentMenu(restaurant) {
    return apiService.post('/restaurants/add-parent-menu', restaurant);
  },
  // Set if restaurant can set meal
  setCanSetMeal(restaurant) {
    return apiService.post('/restaurants/can-set-meal', restaurant);
  },
  // Create restaurant
  createRestaurant(restaurantData) {
    return apiService.post('/restaurants', restaurantData);
  },
  // Update restaurant
  updateRestaurant(restaurantId, restaurantData) {
    return apiService.put(`/restaurants/${restaurantId}`, restaurantData);
  },
  // Delete restaurant
  deleteRestaurant(restaurantId) {
    return apiService.delete(`/restaurants/${restaurantId}`);
  },
  // Save restaurant questionnaires
  saveRestaurantQuestionnaires(restaurantId, questionnaires) {
    return apiService.post(`/restaurants/${restaurantId}/questionnaire`, {
      questionnaires: questionnaires,
    });
  },
  // Change restaurant status
  changeRestaurantStatus(restaurant) {
    return apiService.post('/restaurants/change-restaurant-status', restaurant);
  },
  // Generate restaurant QR code
  generateRestaurantCode(restaurant) {
    return apiService.post('/restaurants/generate-restaurant-code', restaurant);
  },
};

export default restaurantService;
